import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from 'react-redux';

import _ from "lodash";
import cx from "classnames";

import { updateWidgetProperty } from 'actions/editor';
import { EditorContext } from '../../index';

import { Property } from ".";
import styles from './properties.module.scss';

const DropShadow = ({id, properties, handleShadowChange}) => {

  const dispatch = useDispatch();
  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const show = _.get(properties, `show`);

  const handlePropertyChange = (value) => {
    dispatch(updateWidgetProperty(editorSession, id, breakpoint, value));
  }

  const [shadowColor, setShadowColor] = useState(_.get(properties, `color`, {r: 255, g: 255, b: 255, a: 1}));


  const handleShadowColor = (value) => {
    setShadowColor(value);
  };

  useEffect(() => {
    if(_.isEqual(shadowColor, _.get(properties, `color`))){
      return
    }
    handleShadowChange('color', shadowColor);
  }, [shadowColor]);

  return (
    <div className={styles.dropShadow}>
      <div className={styles.toggleShadow}>
        <div className={styles.shadowLable}>Drop Shadow</div>
        <Property.Switch
          value={_.get(properties, "show", false)}
          onChange={()=>handleShadowChange('show', !_.get(properties, "show", false))}
        />
      </div>

      {show && (
        <>
          <div className={styles.fields}>
            <Property.BoxShadow
              value={_.get(properties, "axes", {x: 0, y: 0, b: 0})}
              onChange={(value)=>handleShadowChange('axes', value)}
            />

            <Property.Color
              title="Shadow Color"
              className={styles.shadowColor}
              value={_.get(properties, "color", {r: 255, g: 255, b: 255, a: 1})}
              onChange={handleShadowColor}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default DropShadow;
